exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".decoration-sub-title[data-v-40179099] {\n  display: flex;\n  font-weight: bold;\n  font-size: 1.6rem;\n  line-height: 1.6;\n  box-sizing: border-box;\n  border-bottom: 2px #F08B71 solid;\n  padding-bottom: 8px;\n}\n", ""]);
